import React from 'react';

import { useStyles } from './styles';

export const Divider = () => {
  const classes = useStyles();
  return <div className={classes.divider} />;
};
